import { Dispatch } from 'redux';
import { getCalls } from '../../services/api';
import { GetCallsRequest, CallData, PaginationData } from '../../services/types';

// Action Types
export const FETCH_CALLS_REQUEST = 'FETCH_CALLS_REQUEST';
export const FETCH_CALLS_SUCCESS = 'FETCH_CALLS_SUCCESS';
export const FETCH_CALLS_FAILURE = 'FETCH_CALLS_FAILURE';

export const SET_CALL_SEARCH_TERM = 'SET_CALL_SEARCH_TERM';
export const SET_CALL_CURRENT_PAGE = 'SET_CALL_CURRENT_PAGE';

// Action Interfaces
export interface FetchCallsRequestAction {
  type: typeof FETCH_CALLS_REQUEST;
}

export interface FetchCallsSuccessAction {
  type: typeof FETCH_CALLS_SUCCESS;
  payload: {
    calls: CallData[];
    pagination: PaginationData;
  };
}

export interface FetchCallsFailureAction {
  type: typeof FETCH_CALLS_FAILURE;
  payload: string;
}

export interface SetCallSearchTermAction {
  type: typeof SET_CALL_SEARCH_TERM;
  payload: string;
}

export interface SetCallCurrentPageAction {
  type: typeof SET_CALL_CURRENT_PAGE;
  payload: number;
}

export type CallActionTypes =
  | FetchCallsRequestAction
  | FetchCallsSuccessAction
  | FetchCallsFailureAction
  | SetCallSearchTermAction
  | SetCallCurrentPageAction;

// Action Creators
export const fetchCallsRequest = (): FetchCallsRequestAction => ({
  type: FETCH_CALLS_REQUEST,
});

export const fetchCallsSuccess = (
  calls: CallData[],
  pagination: PaginationData
): FetchCallsSuccessAction => ({
  type: FETCH_CALLS_SUCCESS,
  payload: { calls, pagination },
});

export const fetchCallsFailure = (error: string): FetchCallsFailureAction => ({
  type: FETCH_CALLS_FAILURE,
  payload: error,
});

export const setCallSearchTerm = (searchTerm: string): SetCallSearchTermAction => ({
  type: SET_CALL_SEARCH_TERM,
  payload: searchTerm,
});

export const setCallCurrentPage = (page: number): SetCallCurrentPageAction => ({
  type: SET_CALL_CURRENT_PAGE,
  payload: page,
});

// Thunk Actions
export const fetchCalls = (params?: GetCallsRequest) => {
  return async (dispatch: Dispatch<CallActionTypes>) => {
    dispatch(fetchCallsRequest());
    try {
      const response = await getCalls(params);
      if (response.success) {
        dispatch(fetchCallsSuccess(response.data, response.pagination));
      } else {
        dispatch(fetchCallsFailure(response.message || 'Failed to fetch calls'));
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch calls';
      dispatch(fetchCallsFailure(errorMessage));
    }
  };
};

